// JS root file - include all JS files here
require('./js/misc.js');

// Root CSS file
require('./sass/index.scss');
